var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import styled from "styled-components";
import { greys } from "@irati/ui/src/global/colors";
import { Para } from "@irati/ui/src/Labels";
var RightAlign = styled(Para)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-align: right;\n"], ["\n  text-align: right;\n"])));
var StyledRow = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  padding-top: 15px;\n  padding-bottom: 5px;\n  ", ";\n"], ["\n  display: flex;\n  justify-content: space-between;\n  padding-top: 15px;\n  padding-bottom: 5px;\n  ", ";\n"])), function (_a) {
    var isLast = _a.isLast;
    return (isLast || "border-bottom: 1px solid " + greys.light + ";");
});
var StyledPending = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: block;\n  padding-top: 5px;\n  color: ", ";\n"], ["\n  display: block;\n  padding-top: 5px;\n  color: ", ";\n"])), greys.mediumLight);
var Row = /** @class */ (function (_super) {
    __extends(Row, _super);
    function Row() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Row.prototype.render = function () {
        var _a = this.props, leftText = _a.leftText, rightText = _a.rightText, pending = _a.pending, isLast = _a.isLast;
        return (React.createElement(StyledRow, { isLast: isLast },
            React.createElement(Para, null,
                " ",
                leftText,
                " "),
            React.createElement(RightAlign, null,
                " ",
                rightText,
                pending && React.createElement(StyledPending, null,
                    "pending ",
                    pending))));
    };
    Row.defaultProps = {
        isLast: false,
        pending: undefined
    };
    return Row;
}(PureComponent));
export default Row;
var templateObject_1, templateObject_2, templateObject_3;
